import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Layout from "../common/Layout";

// Super Admin

import Institution from "../Pages/SuperAdminScreen/Institution";
import UpdateInstitution from "../Pages/SuperAdminScreen/Institution/UpdateInstitution";
import Configuration from "../Pages/SuperAdminScreen/Configuration";

// Admin
import AddStaff from "../Pages/AdminScreen/AddStaff";
import AttendanceManagement from "../Pages/AdminScreen/AttendanceManagement";
import ReportAttendanceManagement from "../Pages/AdminScreen/ReportAttendanceManagement";
import CircularManagement from "../Pages/AdminScreen/CircularManagement";
import EditCourse from "../Pages/AdminScreen/CourseManagement/EditCourse";
import FeeManagement from "../Pages/AdminScreen/FeeManagement";
import Login from "../Pages/Login";
import Notification from "../Pages/AdminScreen/Notification";
import Page404 from "../Pages/Page404/Page404";
import Reporting from "../Pages/AdminScreen/Reporting";
import SemesterManagement from "../Pages/AdminScreen/SemesterManagement";
import StudentManagement from "../Pages/AdminScreen/StudentManagement";
import AddEditStudent from "../Pages/AdminScreen/StudentManagement/AddEditStudent";
import LeaveApproval from "../Pages/AdminScreen/LeaveApproval";
import EditFeesManagement from "../Pages/AdminScreen/FeeManagement/EditFeesManagement";
import EditCircularManagement from "../Pages/AdminScreen/CircularManagement/EditCircularManagement";

// Staff components
import ArrivalList from "../Pages/StaffScreen/Arrivals";
import UpdateArrival from "../Pages/StaffScreen/Arrivals/UpdateArrivals";
import Lend from "../Pages/StaffScreen/lend";
import MyAttendance from "../Pages/StaffScreen/Attendance";
import AttendanceList from "../Pages/StaffScreen/AttendanceList";
import AddAttendance from "../Pages/StaffScreen/AttendanceList/AddAttendance";
import Myclasses from "../Pages/StaffScreen/MyClasses";
import UpdateClass from "../Pages/StaffScreen/MyClasses/UpdateClasses";
import AddEditSubject from "../Pages/AdminScreen/SemesterManagement/Subject/AddEditSubject";
import ViewFacualty from "../Pages/StaffScreen/viewfacualty";
import StaffNotification from "../Pages/StaffScreen/notification";
import Admit from "../Pages/StaffScreen/admit";
import Exam from "../Pages/StaffScreen/ExamManagement";
import UpdateMark from "../Pages/StaffScreen/ExamManagement/UpdateMarks";
import ForgotPassword from "../Pages/ForgotPassword";
import Assignment from "../Pages/StaffScreen/Assignment";
import AddEditAssignment from "../Pages/StaffScreen/Assignment/AddEditAssignment";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import HistoricalData from "../Pages/StaffScreen/HistoricalData";
import Migration from "../Pages/StaffScreen/Migration";


// lazy import elements
const Dashboard = lazy(() => import("../Pages/AdminScreen/Dashboard"));
const CourseManagement = lazy(() =>
  import("../Pages/AdminScreen/CourseManagement")
);
// const StaffManagement = lazy(() =>
//   import("../Pages/AdminScreen/StaffManagement")
// );
const StaffManagement = lazy(() =>
  import("../Pages/AdminScreen/StaffManagement")
);
const DashboardLayout = lazy(() => import("../components/DashboardLayout"));

// all routes
const superAdminRoutes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/institution",
        element: <Institution />,
      },
      {
        path: "/configuration",
        element: <Configuration />,
      },
      {
        path: "/institution/updateInstitution",
        element: <UpdateInstitution />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <Page404 />,
  },
];

const adminRoutes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/courseManagement",
        element: <CourseManagement />,
      },
      {
        path: "/courseManagement/editCourse",
        element: <EditCourse />,
      },
      {
        path: "/admit",
        element: <Admit />,
      },
      {
        path: "/staffManagement/editStaff",
        element: <AddStaff />,
      },
      {
        path: "/staffManagement/addStaff",
        element: <AddStaff />,
      },
      {
        path: "/staffManagement",
        element: <StaffManagement />,
      },
      {
        path: "/studentManagement",
        element: <StudentManagement />,
      },
      {
        path: "/studentManagement/add",
        element: <AddEditStudent />,
      },
      {
        path: "/studentManagement/edit",
        element: <AddEditStudent />,
      },
      {
        path: "/semesterManagement",
        element: <SemesterManagement />,
      },
      {
        path: "/subject/edit",
        element: <AddEditSubject />,
      },
      {
        path: "/subject/add",
        element: <AddEditSubject />,
      },
      {
        path: "/reporting",
        element: <Reporting />,
      },
      {
        path: "/notification",
        element: <Notification />,
      },
      {
        path: "/feeManagement",
        element: <FeeManagement />,
      },
      {
        path: "/feeManagement/edit",
        element: <EditFeesManagement />,
      },
      {
        path: "/circularManagement",
        element: <CircularManagement />,
      },
      {
        path: "/circularManagement/edit",
        element: <EditCircularManagement />,
      },
      {
        path: "/attendanceManagement",
        element: <AttendanceManagement />,
      },
      {
        path: "/attendanceManagement/report",
        element: <ReportAttendanceManagement />,
      },
      {
        path: "/leaveApproval",
        element: <LeaveApproval />,
      },
      // {
      //   path: "/institution",
      //   element: <Institution />,
      // },
      // {
      //   path: "/institution/updateInstitution",
      //   element: <UpdateInstitution />,
      // },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <Page404 />,
  },
];

const userRoutes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "/",
        element: <Dashboard />,
      },
      {
        path: "/arrivals",
        element: <ArrivalList />,
      },
      {
        path: "/arrivals/updateArrivals",
        element: <UpdateArrival />,
      },
      {
        path: "/lend",
        element: <Lend />,
      },
      {
        path: "/myAttendance",
        element: <MyAttendance />,
      },
      {
        path: "/studentManagement",
        element: <StudentManagement />,
      },
      {
        path: "/studentManagement/add",
        element: <AddEditStudent />,
      },
      {
        path: "/studentManagement/edit",
        element: <AddEditStudent />,
      },
      {
        path: "/attendanceList",
        element: <AttendanceList />,
      },
      {
        path: "/attendanceList/addAttendance",
        element: <AddAttendance />,
      },
      {
        path: "/assignment/add",
        element: <AddEditAssignment />,
      },
      {
        path: "/assignment/edit",
        element: <AddEditAssignment />,
      },
      {
        path: "/assignment",
        element: <Assignment />,
      },
      {
        path: "/class",
        element: <Myclasses />,
      },
      {
        path: "/class/updateclass",
        element: <UpdateClass />,
      },
      {
        path: "/faculty",
        element: <ViewFacualty />,
      },
      {
        path: "/staffNotification",
        element: <StaffNotification />,
      },

      {
        path: "/exam",
        element: <Exam />,
      },
      {
        path: "/updateMark",
        element: <UpdateMark />,
      },
      {
        path: "/historicalData",
        element: <HistoricalData />,
      },
      {
        path: "/migration",
        element: <Migration />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <Page404 />,
  },
];

// no info and users
const unauthorizedRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
  },
  {
    path: "*",
    element: <Navigate to="/login" replace={true} />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
];

const ROLES_ROUTES = {
  Staff: userRoutes,
  admin: adminRoutes,
  superAdmin: superAdminRoutes,
  undefined: unauthorizedRoutes,
};

const getRoutes = (role = "undefined") => {
  return ROLES_ROUTES[role] ?? unauthorizedRoutes;
};

export default getRoutes;
